import { render, staticRenderFns } from "./pro-baseinfo.vue?vue&type=template&id=c29d4520&scoped=true"
import script from "./pro-baseinfo.vue?vue&type=script&lang=js"
export * from "./pro-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./pro-baseinfo.vue?vue&type=style&index=0&id=c29d4520&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29d4520",
  null
  
)

export default component.exports